/* eslint-disable */
import debounce from 'lodash/debounce';
import iHelpers from './helper';
import iAutocomplete from './autocomplete';
import iDateFormatter from './dateFormatter';

const immoSearchbox = {
    input: $('.immo-js-search-input-city'),
    inputFilter: $('.immo-js-search-input-city-filter'),
    inputGeoId: $('.immo-js-search-input-geoid'),
    inputNumberValidation: $('.immo-js-search-input-number-validate'),
    selectMarketingType: $('.immo-js-search-input-tabMarketingType'),
    selectEstateType: $('.immo-js-search-input-selectEstateType'),
    overlayContentWrapper: $('#overlay-search').find('.IMMO_overlay__content-inner'),
    outputNumberOfHits: $('.immo-js-search-output-number-of-hits'),
    outputNumberOfHitsText: $('.immo-js-search-output-number-of-hits-text'),

    init() {
        if (this.input.length) {
            this.searchboxFirstSearch.init();
            this.searchboxMain.init();
            this.setUtmParameters();

            // set Marketing-Type for default
            var marketingType = this.getMarketingTypeOfRealestate(this.selectEstateType.val());

            // Code wird NUR IM WIDGET benötigt
            if ($('input[name=buyRent]').length) {
                const checkedInput = $('input[name=buyRent]:checked', this.selectMarketingType);
                const defaultInput = $('input[value=buy]:checked', this.selectMarketingType);

                $('input[value=' + marketingType + ']', this.selectMarketingType).prop('checked', true);

                // auf Default setzen.
                this.handleMarketingTypeChanged(checkedInput.val());
                localStorage.setItem('realestatetype', checkedInput.val());
            }

            immoSearchbox.handleEstateTypeChanged(this.selectEstateType.val());
            this.bindEvents();
            this.bindCustomEvents();
        }
    },

    setUtmParameters() {
        let parametersNamedArray = [],
            parameter;

        const query = decodeURIComponent(window.location.search.substring(1)),
            parameters = query.split('&'),
            parameterNames = [
                'utm_source',
                'utm_medium',
                'utm_campaign',
                'utm_content'
            ];

        parameters.forEach(param => {
            parameter = param.split('=');
            if (parameter.length > 1) {
                parametersNamedArray[parameter[0]] = parameter[1];
            }
        });

        parameterNames.forEach(param => {
            let input = document.getElementById(param);
            if (input && parametersNamedArray[param] !== undefined) {
                input.value = parametersNamedArray[param];
            }
        });
    },

    bindCustomEvents() {
        $(window).on('immo-update-numberOfHits-debounced', debounce(function () {
            immoSearchbox.handleUpdateNumberOfHits();
        }, 500));

        $(window).on('immo-update-numberOfHits', function () {
            immoSearchbox.handleUpdateNumberOfHits();
        });
    },

    bindEvents() {
        $('input[name=buyRent]', this.selectMarketingType).on('change', function (event) {
            immoSearchbox.handleMarketingTypeChanged($(this).val());
            $(window).trigger('immo-update-numberOfHits');
        });

        this.selectEstateType.on('focus change', function () {
            immoSearchbox.handleSaveOldSelectValue(this);
        });

        this.selectEstateType.on('change', function () {
            immoSearchbox.handleEstateTypeChanged($(this).val());
            $(window).trigger('immo-update-numberOfHits');
        });

        $(window).on('autocomplete-geocode-set', function () {
            $(window).trigger('immo-update-numberOfHits');
        });
    },

    handleUpdateNumberOfHits() {
        const first = immoSearchbox.searchboxFirstSearch.el.serialize();
        const second = immoSearchbox.searchboxMain.el.serialize();

        const data = (first !== '') ? first : second;
        // Wenn es keine gespeicherte letzte Suche gibt und keine Stadt eingegeben wurde.
        const showLocationErrors = !(localStorage.getItem('lastSearch') === null && this.inputGeoId.val() === '');

        if (this.formIsValid(showLocationErrors)) {
            this.outputNumberOfHits.html('<svg><use xlink:href="#WW_icon-reload"></use></svg>');

            $.ajax({
                type: 'POST',
                url: window.immoSearchboxLoadNumberOfHitsUrl,
                data,
                success: (msg) => {
                    this.outputNumberOfHits.text(msg.count);
                    this.outputNumberOfHitsText.text('Treffer');
                },
                error: () => {
                    this.outputNumberOfHits.text('');
                    this.outputNumberOfHitsText.text('Suchen');
                }
            });
        }
    },

    searchboxFirstSearch: {
        el: $('.immo-js-first-search-form'),
        submit: $('.immo-js-first-search-submit'),
        dateInput: $('.immo-js-search-input-date'),
        filterWrapper: $('.immo-js-search-input-filter-wrapper'),

        init() {
            if (this.el.length > 0) {
                this.deserializeForm();
                this.bindEvents();

                // Update Select Status
                this.filterWrapper.find('select').each(function () {
                    immoSearchbox.searchboxFirstSearch.handleFilterSelectSelected(this);
                });
            }
        },

        bindEvents() {
            this.submit.on('click', function (e) {
                immoSearchbox.searchboxFirstSearch.handleSubmitClicked(e);
            });

            this.filterWrapper.find('select').on('change', function () {
                immoSearchbox.searchboxFirstSearch.handleFilterSelectSelected(this);
            });

            this.filterWrapper.find('select, input').on('keyup', function () {
                $(window).trigger('immo-update-numberOfHits-debounced');
            });

            this.filterWrapper.find('select').on('change', function () {
                $(window).trigger('immo-update-numberOfHits');
            });
        },

        // ==== SerializeForm ====//
        deserializeForm() {
            if (localStorage.lastUpdate) {
                if (localStorage.lastSearch) {
                    this.el.deserialize(localStorage.lastSearch);
                    immoSearchbox.handleUpdateNumberOfHits();
                }
            } else {
                localStorage.removeItem('lastSearch');
            }
        },

        serializeForm() {
            // debugger;
            localStorage.lastSearch = this.el.serialize();
            localStorage.lastUpdate = Date.now();
        },

        // ==== Handler ====//
        handleFilterSelectSelected(element) {
            var el = $(element);
            var val = el.val();
            if (val === '') {
                el.removeClass('selected');
            } else {
                el.addClass('selected');
            }
        },

        handleSubmitClicked(e) {
            e.preventDefault();

            // Wenn mann direkt auf suchen klick, ohne einen Ort zu bestätigen
            // und es Auswahlmöglichkeiten gibt.
            if (immoSearchbox.inputGeoId.val() === '' && iAutocomplete.isOpen && iAutocomplete.isOpen()) {
                iAutocomplete.closeAndSet();
            }

            // Validate inputs - on success submit form - on failure highlight
            // inputs and listen for new.
            if (immoSearchbox.formIsValid()) {
                this.serializeForm();
                this.el.trigger('submit');
            }
        },

        // ==== Filter ====//
        showHideFilters(value) {
            var filter = [];
            switch (value) {
                case 'ApartmentRent':
                case 'ApartmentBuy':
                    filter = [
                        'first_search_minNumberOfRooms',
                        'first_search_radius',
                        'first_search_minLivingSpace',
                        'first_search_maxPrice',
                    ];
                    break;
                case 'FlatShareRoom':
                    filter = [
                        'first_search_radius',
                        'first_search_minLivingSpace',
                        'first_search_startRentalDate',
                        'first_search_maxPrice',
                    ];
                    break;
                case 'LivingBuySite':
                case 'LivingRentSite':
                    filter = [
                        'first_search_radius',
                        'first_search_maxPrice',
                        'first_search_minPlotarea',
                    ];
                    break;
                case 'SeniorCare':
                case 'AssistedLiving':
                    filter = [
                        'first_search_radius',
                    ];
                    break;
                case 'HouseBuy':
                case 'HouseRent':
                case 'HouseType':
                    filter = [
                        'first_search_minNumberOfRooms',
                        'first_search_radius',
                        'first_search_minLivingSpace',
                        'first_search_maxPrice',
                    ];
                    break;
                default:
                    break;
            }

            this.filterWrapper.children().hide();
            filter.forEach(function (element) {
                immoSearchbox.searchboxFirstSearch.filterWrapper.find(`#${element}`).parent().show();
            });
        },


        // Da css die versteckten-Elemente mitzählt müssen wir das hier berechnen.
        // setFilterMargins() {
        //     var filterAll = this.filterWrapper.find('.I_OBJ_searchbox__filter');
        //     var filter = this.filterWrapper.find('.I_OBJ_searchbox__filter:visible:even');
        //
        //     filterAll.removeClass('I_OBJ_searchbox__filter--even');
        //     filter.addClass('I_OBJ_searchbox__filter--even');
        // },
    },

    searchboxMain: {
        el: $('.immo-js-main-search-form'),
        submit: $('.immo-js-main-search-submit'),
        resetButton: $('.immo-js-main-search-filter-abort'),
        filter: $('.immo-js-main-search-filter'),
        tags: $('.immo-js-main-search-tags'),
        mainSearchWidget: $('.immo-js-searchbox'),
        sendFormOnChange: $('.immo-js-search-send-when-changed'), // I-js-FM-1-searchbox-send-when-changed

        // resetIgnore: [
        //     'buyRent',
        //     'realestatetype',
        //     'city',
        //     'geocode'
        // ],

        init() {
            if (this.el.length > 0) {
                this.serializeForm();
                this.bindEvents();
            }
            $('.IMMO_overlay__content-inner').find('select').chosen({
                disable_search: true,
            });
        },
        bindEvents() {
            this.resetButton.on('click', function () {
                $(window).trigger('immo-update-numberOfHits');
            });

            this.submit.on('click', function (e) {
                immoSearchbox.searchboxMain.handleSubmitClicked(e);
            });

            // Send Form on chang
            this.sendFormOnChange.on('change', function () {
                immoSearchbox.searchboxMain.handleSendFormOnChange();
            });

            this.mainSearchWidget.find('input, select').on('change keyup', function () {
                $(window).trigger('immo-update-numberOfHits');
            });

            this.bindFilterEvents();
        },

        bindFilterEvents() {
            this.filter = $('.immo-js-main-search-filter');
            this.filter.find('[data-sibling]').on('change keyup', function (event) {
                const siblingId = $(this).data('sibling');
                const siblingElement = $('#'+siblingId);
                if (siblingElement) {
                    if (siblingElement.val() !== $(this).val()) {
                        siblingElement.val($(this).val());
                        if (siblingElement.is('select')) {
                            siblingElement.trigger('chosen:updated');
                        }
                    }
                }
            });

            this.filter.find('input, select').on('change keyup', function () {
                $(window).trigger('immo-update-numberOfHits-debounced');
            });

            $(window).trigger('init-city-filter-autocomplete');
        },

        serializeForm() {
            localStorage.mainSearch = this.el.serialize();
            localStorage.lastUpdate = Date.now();
        },

        deserializeForm() {
            if (localStorage.lastUpdate) {
                if (localStorage.mainSearch) {
                    this.el.deserialize(localStorage.mainSearch, this.ignore);
                }
            } else {
                localStorage.removeItem('mainSearch');
            }
        },

        // ==== Handler ====//
        handleSendFormOnChange() {
            if (immoSearchbox.formIsValid()) {
                this.el.trigger('submit');
            }
        },

        handleSubmitClicked(e) {
            e.preventDefault();

            // Wenn mann direkt auf suchen klick, ohne einen Ort zu
            // bestätigen und es Auswahlmöglichkeiten gibt.
            if (immoSearchbox.inputGeoId.val() === '' && iAutocomplete.isOpen()) {
                iAutocomplete.closeAndSet();
            }

            // Validate inputs - on success submit form - on failure
            // highlight inputs and listen for new.
            if (immoSearchbox.formIsValid()) {
                this.serializeForm();
                this.el.trigger('submit');
            } else {
                this.el.find('.error:not(.I-js-date-formatter)').on('keyup', function () {
                    // remove error highlighting on new input.
                    $(this).removeClass('error');
                });
            }
        },

        // ==== Filter Main Search ====//
        showHideFilters(value) {
            var filter = [];
            switch (value) {
                case 'ApartmentRent':
                case 'ApartmentBuy':
                case 'HouseBuy':
                case 'HouseRent':
                case 'HouseType':
                    filter = [
                        'main_search_filter_numberofrooms_minNumberOfRooms',
                        'main_search_filter_livingspace_minLivingSpace',
                        'main_search_filter_price_maxPrice',
                        'main_search_maxPrice',
                        'main_search_minLivingSpace',
                        'main_search_minNumberOfRooms',
                        'main_search_radius',
                    ];
                    break;
                case 'FlatShareRoom':
                    filter = [
                        'main_search_filter_livingspace_minLivingSpace',
                        'main_search_filter_startRentalDate',
                        'main_search_filter_price_maxPrice',
                        'main_search_minLivingSpace',
                        'main_search_startRentalDate',
                        'main_search_maxPrice',
                        'main_search_radius',
                    ];
                    break;
                case 'LivingBuySite':
                case 'LivingRentSite':
                    filter = [
                        'main_search_filter_price_maxPrice',
                        'main_search_filter_plotarea_minPlotarea',
                        'main_search_radius',
                    ];
                    break;
                case 'SeniorCare':
                case 'AssistedLiving':
                    filter = [
                        'main_search_radius',
                    ];
                    break;
                default:
                    break;
            }

            this.mainSearchWidget.children().not('.js-search-input-exclude').hide();

            filter.forEach(function (element) {
                immoSearchbox.searchboxMain.mainSearchWidget.find(`#${element}`).parent().show();
            });
        },
    },

    handleEstateTypeChanged(value) {
        // Reset Filters for RealEstateType
        this.searchboxFirstSearch.showHideFilters(value);
        this.searchboxMain.showHideFilters(value);

        // reload Filter Margins
        // this.searchboxFirstSearch.setFilterMargins();

        // reload Filter-Inputs.
        if (localStorage.mainSearch !== '') {
            var map = iHelpers.getMapOfSerializedData(localStorage.mainSearch);
            var estateType = map['main_search[filter][realestatetype]'] || map['main_search[realestatetype]'];
            var city = map['main_search[filterCity]'];
            var radius = map['main_search[filterRadius]'];
            var geocode = map['main_search[geocode]'];

            if (Array.isArray(estateType) && estateType.length) {
                estateType = estateType[0];
            }

            if (estateType !== this.selectEstateType.val()) {
                // remove Tags on Main Search
                // immoSearchbox.searchboxMain.tags.children().remove();
                // immoSearchbox.overlayContentWrapper.children().remove();

                immoSearchbox.overlayContentWrapper.load(window.immoSearchboxSearchboxMainLoadFilterUrl, {
                    'realestatetype': this.selectEstateType.val(),
                    'city': city,
                    'radius': radius,
                    'geocode': geocode
                }, function () {

                    // Chosen-JS reinit;
                    $('.IMMO_overlay__content-inner').find('select').chosen({
                        disable_search: true,
                    });

                    immoSearchbox.selectEstateType = $('.immo-js-search-input-selectEstateType');
                    immoSearchbox.bindEvents();
                    immoSearchbox.searchboxMain.bindFilterEvents();
                });

                immoSearchbox.searchboxMain.serializeForm();
            }
        }
    },

    handleSaveOldSelectValue(element) {
        var el = $(element);
        el.data('last-val', el.val());
    },

    handleMarketingTypeChanged(value) {
        if (value === 'buy') {
            // show/hide options
            this.selectEstateType.find('optgroup[label=Mieten]').wrap('<span>').hide();
            if (this.selectEstateType.find('optgroup[label=Kaufen]').parent().is('span')) {
                this.selectEstateType.find('optgroup[label=Kaufen]').unwrap().show();
            }
        } else {
            // show/hide options
            this.selectEstateType.find('optgroup[label=Kaufen]').wrap('<span>').hide();
            if (this.selectEstateType.find('optgroup[label=Mieten]').parent().is('span')) {
                this.selectEstateType.find('optgroup[label=Mieten]').unwrap().show();
            }
        }

        var arrayOfSameObjectTypes = {
            ApartmentRent: 'ApartmentBuy',
            HouseRent: 'HouseBuy',
            LivingBuySite: 'LivingRentSite',
        };

        if (this.selectEstateType.data('last-val') !== undefined) {
            if (arrayOfSameObjectTypes[this.selectEstateType.data('last-val')] !== undefined) {
                this.selectEstateType.val(arrayOfSameObjectTypes[this.selectEstateType.data('last-val')]);
                this.selectEstateType.data('last-val', arrayOfSameObjectTypes[this.selectEstateType.data('last-val')]);
            } else if (iHelpers.getKeyByValue(arrayOfSameObjectTypes, this.selectEstateType.data('last-val')) !== undefined) {
                var index = iHelpers.getKeyByValue(arrayOfSameObjectTypes, this.selectEstateType.data('last-val'));
                this.selectEstateType.val(index);
                this.selectEstateType.data('last-val', index);
            } else {
                if (value === 'buy') {
                    this.selectEstateType.val(this.selectEstateType.find('optgroup[label=Kaufen]').children().first().val());
                } else {
                    this.selectEstateType.val(this.selectEstateType.find('optgroup[label=Mieten]').children().first().val());
                }
            }
        } else {
            this.selectEstateType.data('last-val', this.selectEstateType.val());
        }
        // Reset Filters for RealEstateType
        this.searchboxFirstSearch.showHideFilters(immoSearchbox.selectEstateType.val());

        // reload Filter Margins
        // this.searchboxFirstSearch.setFilterMargins();

        immoSearchbox.searchboxMain.serializeForm();
    },

    // ==== Validation ====//
    formIsValid(showLocationErrors = true) {
        var hasError = false;

        // Validate Location
        if (this.input.val() === '' || this.inputGeoId.val() === '') {
            if (showLocationErrors) {
                this.input.addClass('error');
            }

            hasError = true;
        }

        // Validate Date
        if (this.searchboxFirstSearch.dateInput.val() !== '' && this.searchboxFirstSearch.dateInput.length > 0) {
            if (!iDateFormatter.dateIsValid(this.searchboxFirstSearch.dateInput.val())) {
                this.searchboxFirstSearch.dateInput.addClass('error');

                hasError = true;
            }
        }

        // Validate is Number / is positiv / is not null
        this.inputNumberValidation.each(function () {
            var number = $(this).val();
            if (number !== '') {
                if (isNaN(Number(number.replace(/\./g, ''))) || Number(number) <= 0) {
                    $(this).addClass('error');

                    hasError = true;
                }
            }
        });

        if (hasError) {
            this.searchboxFirstSearch.el.find('.error').on('keyup', function () {
                // remove error highlighting on new input.
                $(this).removeClass('error');
            });
        }

        return hasError === false;
    },

    // ==== Helper ====//
    getMarketingTypeOfRealestate(realestate) {
        var array = {
            rent: [
                'ApartmentRent',
                'HouseRent',
                'FlatShareRoom',
                'LivingRentSite',
                'SeniorCare',
                'AssistedLiving',
            ],
            buy: [
                'ApartmentBuy',
                'HouseBuy',
                'LivingBuySite',
                'HouseType',
            ],
        };

        if (array.rent.indexOf(realestate) === -1 && array.buy.indexOf(realestate) > -1) {
            return 'buy';
        } else if (array.rent.indexOf(realestate) > -1 && array.buy.indexOf(realestate) === -1) {
            return 'rent';
        }
        return false;
    },
};

export default immoSearchbox;
